import { AbstractControl, ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectorRef, Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ISelectMolecule } from './select.interface';
import { IErrors } from '../input/errors.interface';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => SelectSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR ]
})

export class SelectSharedComponent implements ControlValueAccessor {
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value: any;

    @Input() clearable = false;
    @Input() options: Array<ISelectMolecule> = [];
    @Input() placeholder: string;
    @Input() shadow = false;
    @Input() noBorder = false;
    @Input() errors: Array<IErrors> = [];

    selectedValue: any;
    form: FormGroup;

    get select(): AbstractControl {
        return this.form.get('select');
    }

    get value(): any {
        return this._value;
    }

    set value(val) {
        this.selectedValue = val;
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    constructor(private fb: FormBuilder, private ref: ChangeDetectorRef) {
        this.form = this.fb.group({
            select: [{value: {}, disabled: false}]
        });

        this.select.valueChanges.subscribe(value => {
            this.value = value;
        });
    }

    writeValue(value): void {
        if (typeof value !== 'undefined') {
            this.value = value;
        }

        if (typeof value === 'undefined') {
            this.value = '';
        }

        this.ref.markForCheck();
        this.switched();
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.select.disable();
        } else {
            this.select.enable();
        }
    }

    onChange: any = () => {};
    onTouched: any = () => {};
    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }

    switched(): void {
        this.value = this.selectedValue;
        this.select.setValue(this.selectedValue);
    }
}
